import { render, staticRenderFns } from "./Approvisionnements.vue?vue&type=template&id=0bbf1174&"
import script from "./Approvisionnements.vue?vue&type=script&lang=js&"
export * from "./Approvisionnements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports